/**
 * @module SalesFlow/view
 */

import {Renderable} from '../../renderable';
import {SalesChannelName, SubscriptionGroupName} from 'core/ids';

export abstract class SubscriptionList<T> extends Renderable<T> {

    protected _scrollToFocus: boolean;

    public abstract getEvolvedSubscriptionIds (salesChannel: SalesChannelName, subscriptionGroupName: SubscriptionGroupName): number[];

    public abstract getSubscriptionIds (): number[];

    public setActiveSubscriptionId (subscriptionId: number): void {

    }

    public setScrollToFocus (scrollToFocus: boolean) {
        this._scrollToFocus = scrollToFocus;
    }

}
